import Vue from 'vue'
import { mapGetters, mapState } from 'vuex'

import joinPresentationUtils from '@/utils/join-presentation.utils'

// configs
export default (component) => Vue.component('SpinnerWheelContainer', {
  data() {
    return {
      startConfettiEffect: null,
      myReqAnimationFrame: null,
    }
  },
  computed: {
    ...mapGetters({
      slide: 'activeActivity',
    }),
    ...mapState({
      audienceName: (state) => state.audienceName,
      audienceEmoji: (state) => state.audienceEmoji,
      audienceId: (state) => state.audienceId,
      presentation: (state) => state.presentation,
      audienceQuizTeam: (state) => state.audienceQuizTeam,
    }),
  },
  destroyed() {
    if (this.myReqAnimationFrame) {
      window.cancelAnimationFrame(this.myReqAnimationFrame)
    }
  },
  mounted() {
    this._joinGame()
  },
  methods: {
    isShowFormJoinGame() {
      if (!this.slide.metadata) this.slide.metadata = {}
      if (this.audienceEmoji && this.audienceName) return false
      if (this.slide.metadata && this.slide.metadata.autoFillParticipantName) {
        if (this.slide.metadata.wheelStatus !== 'spinning') {
          if (!this.audienceEmoji || !this.audienceName) return true
        }
      }
      return false
    },
    _joinGame() {
      this.$http
        .post(joinPresentationUtils.getApiUrlJoinPresentation(), {
          a: this.audienceId,
          n: this.audienceName,
          e: this.audienceEmoji,
          c: this.presentation.uniqueAccessCode,
          i: this.slide.id,
          t: this.audienceQuizTeam,
        })
        .then(
          () => {},
          () => {},
        )
    },
  },
  render(createElement) {
    // do not show any footer for white lable users
    return createElement(component, {
      props: {
        isShowFormJoinGame: this.isShowFormJoinGame(),
      },
    })
  },
})
